import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import commonEn from "./locales/en/common.json";
import dashboardEn from "./locales/en/dashboard.json";
import tradingStrategiesEn from "./locales/en/tradingStrategies.json";
import profileEn from "./locales/en/profile.json";
import helpEn from "./locales/en/help.json";
import offersEn from "./locales/en/offers.json";
import partnerOffersEn from "./locales/en/partnerOffers.json";
import signalsEn from "./locales/en/signals.json";
import membershipsEn from "./locales/en/memberships.json";
import addOnsEn from "./locales/en/addOns.json";
import portfolioBuilderEn from "./locales/en/portfolioBuilder.json";
import portfolioTrackerEn from "./locales/en/portfolioTracker.json";

const resources = {
  en: {
    common: commonEn,
    dashboard: dashboardEn,
    tradingStrategies: tradingStrategiesEn,
    profile: profileEn,
    help: helpEn,
    offers: offersEn,
    partnerOffers: partnerOffersEn,
    signals: signalsEn,
    memberships: membershipsEn,
    addOns: addOnsEn,
    portfolioBuilder: portfolioBuilderEn,
    portfolioTracker: portfolioTrackerEn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "dashboard", "tradingStrategies", "profile", "help", "offers", "partnerOffers", "signals", "memberships", "addOns", "portfolioBuilder", "portfolioTracker"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
